import Bg from '../assets/images/background.png';

/**
 * Fundo das telas de autenticacao: a arte do crest coberta pelo mesmo wash navy
 * do login. A arte sozinha e quase branca, entao sem o gradiente a tela nao tem
 * relacao visual nenhuma com o login, e sem `bgSize: cover` no consumidor ela
 * ainda aparece no tamanho natural, cortada num canto.
 *
 * O login monta esse wash com Box sobrepostos, porque ali ele ainda leva as
 * diagonais de steel por cima e o card e translucido.
 */
export const FUNDO_AUTH = `linear-gradient(150deg, rgba(14,31,56,0.94), rgba(16,38,74,0.82)), url(${Bg})`;
